import angular from 'angular';
import animalHistoryComponent from './animal-history.component';

export default angular.module('components.app.adverseEvent.animal-history', [])
  .component('animalHistory', animalHistoryComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/adverse-event/animal-history/animal-history.module.js